import { Plus, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { DeviceSummary } from "@/features/devices/hooks";
import { DeviceBranch, type TreeCtx } from "./TreeNodes";

interface TreePaneProps {
  devices: DeviceSummary[];
  sensorCountByDeviceCode: Map<string, number>;
  query: string;
  setQuery: (q: string) => void;
  ctx: TreeCtx;
  isLoading: boolean;
  isError: boolean;
  onAddClp?: () => void;
}

// Árvore CLP → Cartão → Sensor (painel esquerdo). Busca filtra os 3 níveis.
export function TreePane({
  devices,
  sensorCountByDeviceCode,
  query,
  setQuery,
  ctx,
  isLoading,
  isError,
  onAddClp,
}: TreePaneProps) {
  return (
    <div className="flex min-h-0 flex-col rounded-lg border border-border-default bg-card">
      <div className="border-b border-border-subtle p-2">
        <div className="flex items-center gap-2 rounded-md border border-border-subtle bg-bg-app px-2">
          <Search className="h-4 w-4 shrink-0 text-text-tertiary" />
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Buscar CLP, cartão ou sensor…"
            className="h-9 w-full bg-transparent text-[13px] outline-none placeholder:text-text-tertiary"
            aria-label="Buscar na árvore de CLPs"
          />
        </div>
      </div>

      <div className="min-h-0 flex-1 overflow-auto p-1.5">
        {isError && (
          <p className="px-2 py-3 text-[13px] text-rd-danger-700">
            Não foi possível carregar os CLPs. Tente recarregar a página.
          </p>
        )}
        {isLoading && !isError && (
          <p className="px-2 py-3 text-[13px] text-text-secondary">Carregando…</p>
        )}
        {!isLoading && !isError && devices.length === 0 && (
          <p className="px-2 py-3 text-[13px] text-text-secondary">Nenhum CLP cadastrado.</p>
        )}
        {devices.map((d) => (
          <DeviceBranch
            key={d.id}
            device={d}
            sensorCount={sensorCountByDeviceCode.get(d.code) ?? 0}
            ctx={ctx}
          />
        ))}
      </div>

      <div className="border-t border-border-subtle p-2">
        <Button
          variant="default"
          size="sm"
          className="w-full"
          onClick={onAddClp}
          disabled={!onAddClp}
        >
          <Plus className="h-4 w-4" />
          Novo CLP
        </Button>
      </div>
    </div>
  );
}
